enum PhotoType {
  ALL = 'all',
  PASSED = 'passed',
  FAILED = 'failed',
  FAILED_MATCHES = 'failed_matches',
  MISSING_PPE = 'missing_ppe',
  MATCHING = 'matching', // not used when PHOTO_VERIFICATION_PPE is enabled
}

export default PhotoType;
